import { useTranslation } from 'react-i18next'


export function useLang(){
  const translate = useTranslation().t;
  return {
    translate: (lang: string, options = {}) => translate(lang, options),
  };
}
